<!--<div class="h-full bg-white flex flex-col text-sm pl-5 pr-60 rounded-md">-->
<!--  <div class="text-base mt-5 font-semibold mb-4">Czy na pewno zarchiwizować Jan Kowalski?</div>-->
<!--  <div class="tk-c-gray mb-3">Co zmieni w systemie ta decyzja:</div>-->
<!--  <div class="font-semibold mb-3">Dostęp tego pracownika do aplikacji 4Driver zostanie wyłączony</div>-->
<!--  <div class="font-semibold mb-3">Pojazd tego pracownika nie będzie już do niego przypisany</div>-->
<!--  <div class="font-semibold mb-3">Linki utworzone przez tego pracownika zostaną dezaktywowane</div>-->
<!--  <div class="font-semibold mb-8">Pracownik zostanie zarchiwizowany</div>-->
<!--</div>-->
<!--<div class="flex items-center">-->

<div class="!grid place-items-center !h-full">
  <div>
    <div class="flex bg-white p-5 rounded-xl">
      <div class="font-semibold text-base">
        {{'worker.question-move-to-archive' | translate}} {{worker.FirstName}} {{worker.LastName}}?
      </div>
    </div>

    <div class="mt-4 flex items-center">
      <app-button id="confirm" [isLoading]="isLoading" [isActive]="true" innerTextClasses="text-sm mx-6"
                  spinnerClasses="mx-7 my-1.5"
                  label="{{'worker.move-to-archive' | translate}}" (click)="onDeactivate()"></app-button>

      <sm-button-transparent label="{{'labels.cancel' | translate  | titlecase}}" class="ml-5"
                             (click)="onCancel()"></sm-button-transparent>
    </div>
  </div>
</div>
